<template>
  <Layout>
    <section id="about" class="section align-center">
      <div class="container">
        <div class="row"></div>
        <!--<div class="col-md-7 align-left"> -->
        <h5>Welcome to The EFG Hermes and Tadawul Investor Conference 2021</h5>
        <!-- <h5>Welcome to the 16<sup>th</sup> Annual One on One Conference</h5> -->

        <!-- <p class="meta"><b>Held under the patronage of His Highness Sheikh Maktoum bin Mohammed bin Rashid Al Maktoum,
						Deputy Ruler of Dubai</b></p> -->

        <p>
          The EFG Hermes & Tadawul Investor conference brings market players together digitally.
          Participants will gain access to world-class insights and analysis
          from practitioners, insights which are as valuable as ever in light of
          the extraordinary circumstances which taken hold in global markets.
        </p>
        <!--</div> -->
      </div>
    </section>

    <!-- <section id="tweets" class="section section-sm align-center base-clr-bg dark">
		<div class="container">
			<div class="row">
				<div class="col-xs-12">
					<div class="tweets-container icon-socialmedia-07">
						<div class="tweets slick slider" data-slick='{"slidesToShow": 1, "slidesToScroll": 1, "autoplay": true, "arrows": false, "fade": true}'>
							<div>
								<p class="tweet">
									Throwback: Enjoying two days of investor meetings at The Emirates courtesy of our hosts <a href="#" target="_blank">@efghermes</a> and <a href="#" target="_blank">@ArsenalEvents</a> by Carl Franklin, Chief Investor Relations Officer at Dangote Industries.
								</p>
							</div>
							<div>
								<p class="tweet">
									Throwback: EFG Hermes 6th Annual <a href="#" target="_blank">#LondonMENA</a> & Frontier Conference kicks off today at the Emirates Stadium <a href="http://ow.ly/d/5d56" target="_blank">http://ow.ly/d/5d56</a>

								</p>
							</div>
							<div>
								<p class="tweet">
									Throwback: Key note speakers at EFGHermes 6th <a href="#" target="_blank">#LondonMENA</a> include H.E. Amr El-Garhy, Minister of Finance of the Arab Republic of Egypt
								</p>
							</div>
							<div>
								<p class="tweet">
									Throwback: <a href="#" target="_blank">@efghermes</a> hosts <a href="#" target="_blank">#London</a> conference for <a href="#" target="_blank">#MENA</a> investment <a href="#" target="_blank">#Egypt</a> <a href="#" target="_blank">#business</a> <a href="http://ow.ly/jGlB303Uqqp" target="_blank">http://ow.ly/jGlB303Uqqp</a> by Daily News Egypt
								</p>
							</div>
							<div>
								<p class="tweet">
									Throwback: This year's <a href="#" target="_blank">#LondonMENA</a> broadened its customary focus to include, for the first time ever, listed companies from frontier markets.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> -->

    <!-- <section id="why-attend" class="section text-center">
		<div class="container">
			<h3>Confirmed Speakers</h3>
			<br />
			<br />
			<div class="row">
				<div class="col-md-4 mb-30 animated" data-animation="fadeInUp">
					<div class="person" data-mh="person">
						<div class="person__photo">
							<img src="http://placehold.it/250x250" alt="">
						</div>

						<div class="person__info">
							<h6 class="person__name">His Excellency Dr. Ahmed Abdulkarim Alkholifey</h6>
							<p class="person__title">Governor</p>
							<p class="person__affiliation">Saudi Arabian Monetary Agency</p>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-30 animated" data-animation="fadeInUp" data-delay="100">
					<div class="person" data-mh="person">
						<div class="person__photo">
							<img src="http://placehold.it/250x250" alt="">
						</div>

						<div class="person__info">
							<h6 class="person__name">His Excellency Rasheed Mohammed Al Maraj</h6>
							<p class="person__title">Governor</p>
							<p class="person__affiliation">Central Bank of Bahrain</p>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-30 animated" data-animation="fadeInUp" data-delay="200">
					<div class="person" data-mh="person">
						<div class="person__photo">
							<img src="http://placehold.it/250x250" alt="">
						</div>

						<div class="person__info">
							<h6 class="person__name">His Excellency Dr. Kairat Kelimbetov</h6>
							<p class="person__title">Governor</p>
							<p class="person__affiliation">Astana International Financial Centre (AIFC)</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> -->

    <section
      id="counters"
      class="section align-center gradient-overlay bg-cover bg3 light-text"
    >
      <div class="container">
        <h3 class="text-center animated" data-animation="fadeInUp">
          Market Overview
        </h3>
        <br />

        <div class="col-md-12">
          <p class="white-color title">
            Saudi Arabia’s stock market continues to thrive, having been
            upgraded to emerging market status in 2019-20. Foreign institutions
            are still bringing fresh money into the market in 2021, and high
            levels of retail interest are supporting turnover. The benchmark
            Tadawul Index has delivered a total return of 20%+ in 2021 YTD,
            surpassing the MSCI EM Index (total return of 6%) and the S&P500
            Index (total return of 12%). Tadawul has already seen two successful
            IPOs in 2021 YTD with a strong IPO pipeline.
          </p>
        </div>

        <!-- <div class="row counters-wrapper">
				<div class="col-sm-3">
					<div class="counter-block counter-block-no-border counter-block-white">
						<div class="counter-box">
							<div class="counter-content">
								<span class="count" data-from="0" data-to="260">260</span>

								<p class="title"></i> Financial Institutions</p>
							</div>
						</div>
					</div>
				</div>

				<div class="col-sm-3">
					<div class="counter-block counter-block-no-border counter-block-white">
						<div class="counter-box">
							<div class="counter-content">
								<sub class="append">USD</sub>
								<span class="count" data-from="0" data-to="11">11</span>
								<sub class="prepend">TRN</sub>

								<p class="title">In AUMs</p>
							</div>
						</div>
					</div>
				</div>

				<div class="col-sm-3">
					<div class="counter-block counter-block-no-border counter-block-white">
						<div class="counter-box">
							<div class="counter-content">

								<span class="count" data-from="0" data-to="186">186</span>

								<p class="title">Top-listed companies </p>
							</div>
						</div>
					</div>
				</div>

				<div class="col-sm-3">
					<div class="counter-block counter-block-no-border counter-block-white">
						<div class="counter-box">
							<div class="counter-content">
								<span class="count" data-from="0" data-to="26">26</span>

								<p class="title">Countries</p>
							</div>
						</div>
					</div>
				</div>
			</div> -->
      </div>
    </section>

    <!-- <section id="timeline" class="section gray-clr-bg">
		<div class="container">
			<h3 class="text-center animated" data-animation="fadeInUp">Every Year at the Dubai Conference </h3>
			<br />
			<br />
			<div class="timeline-years slick animated" data-animation="fadeInUp">
				<div>2010</div>
				<div>2012</div>
				<div>2013</div>
				<div>2014</div>
				<div>2015</div>
				<div>2016</div>
				<div>2017</div>
				<div>2018</div>
				<div>2019</div>
			</div>

			<div class="no-free-will animated" data-animation="fadeInUp">
				<div class="timeline-content-navigation">
					<a href="#" class="prev">
						<span class="icon icon-arrows-03"></span>
					</a>
					<a href="#" class="next">
						<span class="icon icon-arrows-04"></span>
					</a>
				</div>

				<div class="timeline-content slick">
					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2010.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>Regional Economies, Global Networks</h5>
								<p>The economic outlook for the MENA region was forecasted to strengthen in 2010 with the improved outlook for
									the global economy. Oil prices were expected to remain at a very conformable level for the oil-exporting
									economies while the more diversified economies were expected to benefit from the pickup in remittances,
									tourism and wider exports, which were also key driver of domestic demand. We forecasted that the majority of
									the MENA countries would see a strengthening in their domestic demand outlooks. In light of this, the 8th
									Annual EFG Hermes One-on-One Conference held in Sharm El-Sheikh was a premiere regional event at which leading
									global investors interacted with top executives and high-ranking government officials from the Arab world in a
									relaxed-yet-business-like environment to forge new relationships and deepen long-standing ties.</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2012.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>Bridging the Gap</h5>
								<p>With the Arab world undergoing a historical political transition in the context of a global economy that was
									also going through significant transformation, there had never been a more fitting time for a one-on-one
									interaction in the region. This year, the scope of the conference was widened to include non-Arab African
									companies for the first time, offering emerging market investors exciting opportunities backed by favourable
									demographics and sound economic fundamentals. The conference, located in Sharm El Sheikh, Egypt, provided an
									effective platform for companies to communicate their investment stories to current and potential investors,
									whilst collectively encouraging investment in the region.</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2013.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>Your Gateway to MENA</h5>
								<p>The outlook for 2013 varied greatly between the oil-exporters and the oil-importers. For the GCC countries,
									expansionary government spending resulted in a multi-faceted domestic demand story while oil-importers faced a
									number of challenges, notably balancing social factors and economic growth. Fiscal reforms were expected to
									result in compressed margins for both corporates and individuals resulting in weaker growth. The 9th Annual
									EFG Hermes One on One Conference, which was held in Luxor, provided key insights for those seeking to invest
									in MENA's rapid growth, with high-ranking government officials from across the MEA in attendance to cast light
									on the latest developments and investment opportunities in the region.</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2014.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>Celebrating a Decade of Success</h5>
								<p>The 10th annual EFG Hermes One on One Conference offered a perfect opportunity to explore a wide range of
									new ideas and strategies in light of the region's emerging realities, with all the diverse challenges and
									exciting opportunities they presented. With Dubai ramping up spending in the wake of winning its bid to host
									the Dubai Expo 2020, UAE and Qatar's upgrade to emerging market status, Morocco's downgrade to frontier market
									status and Egypt's apparent enactment of its political roadmap, 2014 looked set to be an exciting year for
									investors and companies alike and the conference provided an ideal forum to gain cutting edge market
									intelligence and create crucial business connections with senior business leaders.</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2015.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>A Region of Opportunities </h5>

								<p>The 2015 conference was met with one of the most compelling macroeconomic backdrops the MENA region had
									witnessed in years. With a strong pipeline of IPOs in Egypt and the UAE, an uptick in M&A transactions and
									Saudi's decision to open its market to foreign investors, 2016 was an interesting year full of opportunities
									for investors and companies alike. Our conference provided the perfect venue for key global equity investors
									to network with high-level executives from leading MENA companies, gain on-the-ground market insights and
									cultivate regional and international business connections. </p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2016.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>MENA: Opportunities Beyond Oil</h5>

								<p>The 2016 conference shaped up to be a particularly crucial meeting as we witnessed major global changes that
									had significant repercussions on the investment climate in the region. As the year 2015 drew to a close, we
									saw the continued rollout of new political and economic realities across the region, with new challenges
									bringing new opportunities. In Egypt, a new Central Bank of Egypt governor had just taken the helm and natural
									gas flows to industry improved substantially. Meanwhile, the outlook for the UAE and Kuwait was broadly
									positive, with the UAE's diverse economy and Kuwait's financial reserves helping both economies withstand the
									impact of lower oil prices. The EFG Hermes' One on One Conference provided companies and investors with the
									perfect venue to discuss these new regional realities and explore compelling opportunities that went beyond
									oil and tapped into the core fundamentals of regional economies. </p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2017.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>The Pulse of MENA & Frontier Markets</h5>

								<p>The 2017 conference came in a challenging year for emerging and frontier markets. With Brexit and the
									election of Donald Trump resulting in the rising risk of protectionism to EM growth, as well as the rising
									dollar and US bond yields, EM have relied on their own internal factors, such as economic reform and
									attractive demographic dynamics, to retain their growth trajectories and attract FDI. Amid conflicting signals
									about the global outlook and investment prospects, it was a key setting for equity investors to meet
									face-to-face with regional high-level executives and industry professionals in a custom backdrop designed for
									open dialogue and the exploration of compelling investment opportunities.</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2018.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>Shifting Benchmarks: Frontier Emerging Markets</h5>

								<p>The 2018 conference came on the heels of strong economic growth, favorable demographics, a growing
									consumer-driven middle class and advancing reform agendas enabling MENA and frontier emerging markets to gain
									considerable traction among investors in 2017, with year-to-date fund inflows at record highs in multiple
									geographies. Shifting dynamics for oil and the USD, weaker commodity prices and a pivot in Chinese-led growth
									and several regional policy reforms and political turbulences were among the key themes of discussed in 2018.
									The conference provided unmatched access and insights to investors and fund managers seeking to explore the
									region's shifting benchmarks and identify investment plays.</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-4 mb-30">
								<img src="./assets/img/history/dubai-2019.jpg" alt="">
							</div>

							<div class="col-md-8">
								<h5>Navigating the Path to Opportunities</h5>

								<p>The 2019 conference came after yet another challenging year for Emerging and Frontier Markets. In spite of improved valuations following weak performance in 2018, increases in US interest rates continued to pose a challenge for heavily indebted FEM markets. Stimulus measures offered diminishing returns to scale for the Chinese economy, regarded as an increasingly important engine for FEM growth. The year saw two strong themes throughout FEM - (1) index upgrades and the impact of passive flows on Saudi Arabia and often-overlooked Kuwait and (2) ongoing recovery in markets that have already taken steps to rebalance their economies, such as Egypt and Pakistan.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> -->

    <section id="agenda" class="section schedule-section align-center">
      <div class="container">
        <span class="icon section-icon icon-office-21"></span>
        <h3>Agenda</h3>
        <br />
        <p>Saudi Arabia Standard Time [UTC+03]</p>
        <p style="color: #51545b; font-size: 18px">
          Click
          <a href=" https://www.thetimezoneconverter.com" target="_blank"
            ><b>here </b></a
          >for time zone converter
        </p>
        <br />

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <!-- Schedule start -->
            <div class="schedule">
              <!-- Navigation by day start -->
              <ul class="nav nav-schedule">
                <li class="active">
                  <a href="#schedule3_day1" data-toggle="tab">
                    <h5 class="highlight">14 - 15</h5>
                    <p class="text-alt">June, 2021</p>
                  </a>
                </li>
                <li>
                  <a href="#schedule3_day2" data-toggle="tab">
                    <h5 class="highlight">16 - 17</h5>
                    <p class="text-alt">June, 2021</p>
                  </a>
                </li>

                <!-- <li><a href="#schedule3_day4" data-toggle="tab">
									<h5 class="highlight">Day 4: Thursday</h5>
									<p class="text-alt">June 25, 2020</p>
								</a></li> -->
              </ul>
              <!-- Navigation by day end -->

              <!-- First level content start -->
              <div class="tab-content">
                <!-- Day 1 content start -->
                <div id="schedule3_day1" class="tab-pane fade active in">
                  <!-- Second level content start -->
                  <div class="tab-content tab-content-schedule">
                    <!-- Main content start -->
                    <div
                      id="schedule3_day1_main"
                      class="tab-pane fade active in"
                    >
                      <!-- Accordion start -->
                      <div
                        class="panel-group"
                        id="schedule3_day1_main_timeline"
                      >
                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>09:00 -
                              09:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>One on One Virtual Meetings</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>10:00 -
                              10:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i></strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>11:00 -
                              11:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>6th, 7th, 8th & 9th Floor, West Wing, Atlantis</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>12:00 -
                              12:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Saffron Restaurant, Atlantis</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>13:00 -
                              13:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>6th, 7th, 8th & 9th Floor, West Wing, Atlantis</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>14:00 -
                              14:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>15:00 -
                              15:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>16:00 -
                              16:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>17:00 -
                              17:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>18:00 -
                              18:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->
                      </div>
                      <!-- Accordion end -->
                    </div>
                    <!-- Main content end -->
                  </div>
                  <!-- Second level content end -->
                </div>
                <!-- Day 1 content end -->

                <!-- Day 2 content start -->
                <div id="schedule3_day2" class="tab-pane fade in">
                  <!-- Second level content start -->
                  <div class="tab-content tab-content-schedule">
                    <!-- Main content start -->
                    <div
                      id="schedule3_day2_main"
                      class="tab-pane fade active in"
                    >
                      <!-- Accordion start -->
                      <div
                        class="panel-group"
                        id="schedule3_day2_main_timeline"
                      >
                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>09:00 -
                              09:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>One on One Virtual Meetings</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>10:00 -
                              10:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i></strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>11:00 -
                              11:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>6th, 7th, 8th & 9th Floor, West Wing, Atlantis</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>12:00 -
                              12:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Saffron Restaurant, Atlantis</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>13:00 -
                              13:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>6th, 7th, 8th & 9th Floor, West Wing, Atlantis</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end -->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>14:00 -
                              14:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>15:00 -
                              15:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>16:00 -
                              16:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>17:00 -
                              17:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->

                        <!-- Lecture start -->
                        <div
                          class="panel schedule-item animated"
                          data-animation="fadeIn"
                          data-delay="0.5s"
                        >
                          <div class="lecture-icon-wrapper"></div>
                          <div class="schedule-item-toggle">
                            <strong class="time highlight"
                              ><i class="icon fa fa-clock-o"></i>18:00 -
                              18:50</strong
                            >
                            <br />
                            <!-- <strong class="location highlight"><i class="icon fa fa-map-marker"></i>Venue TBC</strong> -->
                          </div>
                          <h6 class="title">One on One Virtual Meetings</h6>
                        </div>
                        <!-- Lecture end-->
                      </div>
                      <!-- Accordion end -->
                    </div>
                    <!-- Main content end -->
                  </div>
                  <!-- Second level content end -->
                </div>
                <!-- Day 2 content end -->
              </div>
              <!-- First level content end -->
            </div>
            <!-- Schedule end -->
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="why-attend" class="section text-center gray-clr-bg">
		<div class="container">
			<h3>Why Attend?</h3>
			<br />
			<br />
			<div class="row">
				<div class="icon-box col-md-3 animated mb-30" data-animation="fadeIn">
					<img
						class="icon section-icon animated" src="./assets/img/icons/meeting-room.svg" alt="" width="50"
						data-animation="fadeInUp"
						style="margin-left: auto; margin-right: auto;"
						>
					<p>
						The largest MENA and Frontier markets-focused conference.
					</p>
				</div>

				<div class="icon-box col-md-3 animated mb-30" data-animation="fadeIn" data-delay="100">
					<span
						class="section-icon icon icon-realestate-living-03 animated"
						data-animation="fadeInUp"
						data-delay="150"></span>
					<p>
						Access to one-on-one meetings with fund managers, institutional investors and C-suite executives.
					</p>
				</div>

				<div class="icon-box col-md-3 animated mb-30" data-animation="fadeIn" data-delay="200">
					<span
						class="section-icon icon icon-seo-icons-01 animated"
						data-animation="fadeInUp"
						data-delay="250"></span>
					<p>
						Gain insights into some of the worldâ€˜s fastest growing markets and the compelling opportunities they offer.
					</p>
				</div>

				<div class="icon-box col-md-3 animated mb-30" data-animation="fadeIn" data-delay="300">
					<span
						class="section-icon icon icon-text-hierarchy-04 animated"
						data-animation="fadeInUp"
						data-delay="350"></span>
					<p>
						Network with peers with all over the world and build fruitful relationships
					</p>
				</div>
			</div>
		</div>
	</section> -->
    <!--
	<section class="section gray-clr-bg">
		<div class="container">
			<div class="no-free-will">
				<div class="row">
					<div class="bottom-links">
						<div class="col-md-6">
							<a href="#" class="btn btn-sm btn-secondary btn-block">Participation Guidelines (Presenters)</a>
						</div>
						<div class="col-md-6">
							<a href="#" class="btn btn-sm btn-secondary btn-block">Brochure (Investors)</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> -->
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
  name: "home",
  components: { Layout },
};
</script>
